import React, { useState, useEffect } from 'react';

const TablaCatalogos = (p) => {
    const contenedor = p.contenedor ?? 'bw-1200 vh-70 round-m bg-white border shadow p-0 mt-1 overflow p-0';
    const tableStyle = p.tableStyle ?? 'table table-sm table-hover p-0 m-0';
    const thStyle = p.headStyle ?? 'nowrap text-center';
    const tdStyle = p.tdStyle ?? 'nowrap pointer text-center';
    const noDataMessage = p.noDataMessage ?? 'No hay datos para mostrar';
    const keys = p.keys ?? [];
    const data = p.data ?? [];
    if (data.length == 0) return (
        <div className='w-100 h-100 p-2'>
            <div className='w-100 p-3 text-center text-bold h4'>{noDataMessage}</div>
        </div>
    )

    return (
        <div className={contenedor}>
            <table className={tableStyle}>
                <thead>
                    <tr>{keys.map((key) => <th scope='col' className={thStyle} key={key.key}>{key.name}</th>)}</tr>
                </thead>
                <tbody>
                    {data.map((res, i) =>
                        <tr key={"row" + i}>
                            {keys.map((key, j) =>
                                <td scope='col' className={tdStyle} key={i + key.key + j}
                                    onClick={() => { if (p.funcion) p.funcion(res) }}
                                >{res[key.key]}</td>
                            )}
                        </tr>)}

                </tbody>
            </table>
        </div>
    )
}

export default TablaCatalogos;